<template>
  <main class="payment-result">
    <h2>{{ confirmed ? '支付成功' : '正在确认支付结果' }}</h2>
    <p v-if="confirmed && order">实付款 ¥{{ (Number(order.total) + Number(order.deliveryFee) - Number(order.couponDiscount || 0)).toFixed(2) }}</p>
    <p>{{ error }}</p>
    <el-button @click="$router.replace('/cashier/' + $route.params.id)">查询支付结果</el-button>
    <el-button @click="$router.replace('/OrderInfoView/' + $route.params.id)">查看订单</el-button>
  </main>
</template>
<script>
import request from '../axios/request'
export default {
  name: 'PaySuccessView', data: () => ({ confirmed: false, order: null, error: '' }),
  async mounted () {
    try {
      const result = await request.post('/api/pay/web/' + this.$route.params.id + '/status')
      if (result.data.status !== 200 || !result.data.data.paid) { this.error = '尚未确认付款成功，请返回收银台查询'; return }
      this.confirmed = true
      const detail = await request.get('/order/api/getOrderInfo/' + this.$route.params.id)
      if (detail.data.status === 200) this.order = detail.data.data
    } catch (e) { this.error = '支付结果查询失败，请稍后重试' }
  }
}
</script>
<style scoped>.payment-result{padding:32px 16px;text-align:center}</style>
